import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/pcTerminal/HomeView.vue'

Vue.use(VueRouter)

const ProductsServe = () => import(/* webpackChunkName: "products" */ '../views/pcTerminal/ProductsServe.vue')
const ProductsServeMobile = () => import(/* webpackChunkName: "products-mobile" */ '../views/mobileTerminal/ProductsServeMobile.vue')
const PublishingView = () => import(/* webpackChunkName: "publishing" */ '../views/pcTerminal/PublishingView.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/electricPower',
    name: 'electricPower',
    component: ProductsServe
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/pcTerminal/AboutView.vue')
  },
  {
    path: '/connect',
    name: 'connect',
    component: () => import(/* webpackChunkName: "about" */ '../views/pcTerminal/ConnectUs.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsServe
  },
  {
    path: '/publishing',
    name: 'publishing',
    component: PublishingView
  },
  // 移动端首页
  {
    path: '/home-view-mobile',
    name: 'HomeViewMobile',
    component: () => import( '../views/mobileTerminal/HomeViewMobile.vue')
  },
  {
    path: '/electric-power-mobile',
    name: 'ElectricPowerMobile',
    component: ProductsServeMobile
  },
  {
    path: '/products-serve-mobile',
    name: 'ProductsServeMobile',
    component: ProductsServeMobile
  },
  {
    path: '/publishing-mobile',
    name: 'PublishingMobile',
    component: PublishingView
  },
  {
    path: '/about-mobile',
    name: 'AboutMobile',
    component: () => import( '../views/mobileTerminal/AboutMobile.vue')
  },
  {
    path: '/connect-us-mobile',
    name: 'connect-us-mobile',
    component: () => import( '../views/mobileTerminal/ConnectUsMobile.vue')
  },
  {
    path:'/successful-case',
    name: 'SuccessfulCase',
    component: () => import( '../views/mobileTerminal/SuccessfulCase.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
